export type GuideTourTargetMeasureScheduler = {
  /** Coalesces to after layout paint (double rAF). */
  scheduleMeasure: () => void
  /** Runs measurement immediately (e.g. scroll polling). */
  measureNow: () => void
  cancelScheduledMeasure: () => void
}

export const createGuideTourTargetMeasureScheduler = (
  measure: () => void
): GuideTourTargetMeasureScheduler => {
  let outerFrameId = 0
  let innerFrameId = 0

  const cancelScheduledMeasure = () => {
    if (outerFrameId) {
      window.cancelAnimationFrame(outerFrameId)
      outerFrameId = 0
    }

    if (innerFrameId) {
      window.cancelAnimationFrame(innerFrameId)
      innerFrameId = 0
    }
  }

  const measureNow = () => {
    cancelScheduledMeasure()
    measure()
  }

  const scheduleMeasure = () => {
    if (outerFrameId || innerFrameId) {
      return
    }

    outerFrameId = window.requestAnimationFrame(() => {
      outerFrameId = 0
      innerFrameId = window.requestAnimationFrame(() => {
        innerFrameId = 0
        measure()
      })
    })
  }

  return {
    scheduleMeasure,
    measureNow,
    cancelScheduledMeasure,
  }
}
